const parseBoolean = (value, defaultValue = false) => {
  if (typeof value !== 'string') return defaultValue;
  return value.trim().toLowerCase() === 'true';
};

const normalizeUrl = (value, name) => {
  const url = (value || '').trim().replace(/\/+$/, '');
  if (!url) throw new Error(`${name} must be configured.`);
  return url;
};

// Docker writes this object to /env.js when the container starts. The build-time
// value remains as a fallback for local development and non-Docker deployments.
const runtimeConfig = window.__APP_CONFIG__ || {};
const apiBaseUrl = normalizeUrl(
  runtimeConfig.API_BASE_URL || process.env.REACT_APP_API_BASE_URL,
  'REACT_APP_API_BASE_URL'
);

export const appConfig = Object.freeze({
  apiBaseUrl,
  authApiBaseUrl: `${apiBaseUrl}/authentication`,
  enableHotjar: parseBoolean(process.env.REACT_APP_ENABLE_HOTJAR),
  enableGravatar: parseBoolean(process.env.REACT_APP_ENABLE_GRAVATAR),
  sharingBaseUrl: (process.env.REACT_APP_SHARING_BASE_URL || window.location.origin).replace(/\/+$/, ''),
});

// Kept as a named export for existing consumers.
export const baseSharingUrl = appConfig.sharingBaseUrl;
